import { Pipe, PipeTransform } from '@angular/core';
import { StringUtils } from '../../utils/string.utils';

@Pipe({
  name: 'searchList'
})
export class SearchListPipe implements PipeTransform {
  transform(list: any[], filterText: string, fieldName: string = 'name'): any {
    if (StringUtils.isEmpty(filterText) || !list) {
      return list;
    }

    filterText = StringUtils.turkishToEnglish(filterText.toUpperCase());

    return list.filter(item => {
      const fieldValue = StringUtils.turkishToEnglish(item[fieldName]?.toUpperCase());

      return fieldValue.includes(filterText);
    });
  }
}

